import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./index.css";

// Recover automatically if Vite encounters a stale chunk after an update
window.addEventListener('vite:preloadError', (event) => {
  console.warn('Vite preload error encountered, reloading with fresh chunks...', event);
  const reloaded = sessionStorage.getItem('vite_preload_reloaded');
  if (!reloaded) {
    sessionStorage.setItem('vite_preload_reloaded', 'true');
    window.location.reload();
  }
});
window.addEventListener('load', () => {
  sessionStorage.removeItem('vite_preload_reloaded');
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

